// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Atom_Icon = require("../Atom_Icon.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");

var icons = [
  {
    NAME: "AD",
    VAL: undefined
  },
  {
    NAME: "STM",
    VAL: undefined
  },
  {
    NAME: "VF",
    VAL: undefined
  },
  {
    NAME: "VO",
    VAL: undefined
  },
  {
    NAME: "ST",
    VAL: undefined
  },
  {
    NAME: "OV",
    VAL: undefined
  },
  {
    NAME: "UT",
    VAL: undefined
  },
  {
    NAME: "DE",
    VAL: undefined
  },
  {
    NAME: "OmU",
    VAL: undefined
  },
  {
    NAME: "STE",
    VAL: undefined
  },
  {
    NAME: "ADU",
    VAL: undefined
  },
  {
    NAME: "BW",
    VAL: undefined
  },
  {
    NAME: "DOL",
    VAL: undefined
  },
  {
    NAME: "HD",
    VAL: undefined
  },
  {
    NAME: "WID",
    VAL: undefined
  },
  {
    NAME: "WRN",
    VAL: undefined
  },
  {
    NAME: "Angle",
    VAL: [
      "Down",
      undefined
    ]
  },
  {
    NAME: "Angle",
    VAL: [
      "Left",
      undefined
    ]
  },
  {
    NAME: "Angle",
    VAL: [
      "Right",
      undefined
    ]
  },
  {
    NAME: "Angle",
    VAL: [
      "Top",
      undefined
    ]
  },
  "Arrow",
  "BurgerMenu",
  "CloseWithBackground",
  "ComingSoon",
  "Desktop",
  "Download",
  "Error",
  {
    NAME: "Facebook",
    VAL: "Footer"
  },
  {
    NAME: "Facebook",
    VAL: "Sharebar"
  },
  {
    NAME: "Heart",
    VAL: "Default"
  },
  {
    NAME: "Heart",
    VAL: "Filled"
  },
  "Home",
  "Geoblocking",
  "Info",
  {
    NAME: "Instagram",
    VAL: "Footer"
  },
  {
    NAME: "Instagram",
    VAL: "Header"
  },
  {
    NAME: "MegaPhone",
    VAL: undefined
  },
  "MenuClose",
  "MenuConcert",
  {
    NAME: "MessageClose",
    VAL: undefined
  },
  "Pause",
  "Play",
  "Plus",
  "RectClose",
  {
    NAME: "Search",
    VAL: undefined
  },
  "Share",
  "SmartPhone",
  {
    NAME: "CircleCheck",
    VAL: "Arte"
  },
  {
    NAME: "CircleCheck",
    VAL: "Success"
  },
  "Tablet",
  "TeaserPlay",
  {
    NAME: "Tv",
    VAL: undefined
  },
  {
    NAME: "Twitter",
    VAL: "Footer"
  },
  {
    NAME: "Twitter",
    VAL: "Sharebar"
  },
  "User",
  "Whatsapp",
  {
    NAME: "Youtube",
    VAL: "Footer"
  },
  {
    NAME: "Youtube",
    VAL: "Header"
  }
];

function Atom_Icon_Internal(Props) {
  var icon = Props.icon;
  var sizeOpt = Props.size;
  var title = Props.title;
  var size = sizeOpt !== undefined ? Caml_option.valFromOption(sizeOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");
  var tmp = {
    icon: icon,
    size: size
  };
  if (title !== undefined) {
    tmp.title = title;
  }
  return React.createElement(Atom_Icon.make, tmp);
}

var make = Atom_Icon_Internal;

exports.icons = icons;
exports.make = make;
/* react Not a pure module */
